<template>
	<div class="py-4 container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="card mb-4">
					<div class="card-header pb-0">
						<h4>Scuderia {{ stableName }}</h4>
						<button
							type="button"
							id="add-btn"
							class="btn btn-primary"
							@click="clear"
							data-bs-toggle="modal"
							data-bs-target="#formModal"
						>
							+ {{ $t('add').toUpperCase() }}
						</button>
					</div>
					<div class="card-body px-0 pt-0 pb-2">
						<custom-table
							ref="table$"
							:rows="data"
							@action="runAction"
							:columns="[
								{
									title: 'Nome box',
									type: 'text',
									data: 'name',
								},
								{
									title: 'Truciolo',
									type: 'boolean',
									data: 'truciolo',
									on_label: 'Si',
									off_label: 'No',
								},
								{
									title: 'Tipo di box',
									type: 'text',
									data: 'box_type_name',
								},
							]"
							:actions="[
								{
									title: 'Cancella',
									tooltip: 'delete',
									key: 'delete',
								},
								{
									title: 'Modifica',
									tooltip: 'edit',
									key: 'edit',
								},
							]"
							:pagination="pagination"
							@page-changed="handlePageChange"
							@update-pagination="handlePaginationUpdate"
							@search-changed="handleSearchChange"
						/>
					</div>
				</div>
			</div>
		</div>

		<div
			class="modal fade"
			id="formModal"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
			tabindex="-1"
			aria-labelledby="add"
			aria-hidden="true"
		>
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="formModalBtn">{{ modalTitle }}</h5>
						<button
							type="button"
							class="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
							style="color: black; font-size: 2rem"
						>
							<span
								aria-hidden="true"
								class="d-block"
								style="margin-top: -0.5rem"
								>&times;</span
							>
						</button>
					</div>
					<div class="modal-body">
						<Vueform ref="form$" v-model="box" sync>
							<HiddenElement name="id" />
							<text-element
								name="name"
								:label="$t('first_name')"
								rules="required"
							></text-element>

							<RadiogroupElement
								name="truciolo"
								label="Truciolo"
								rules="required"
								:items="[
									{ value: false, label: 'No' },
									{ value: true, label: 'Si' },
								]"
							></RadiogroupElement>
							<SelectElement
								name="box_type_id"
								:native="false"
								label="Tipo di box"
								rules="required"
								:items="box_types"
							/>
							<SelectElement
								name="horse_stable_id"
								:native="false"
								label="Scuderia"
								rules="required"
								:items="horse_stables"
								:default="horseStable_id"
							/>
						</Vueform>
					</div>
					<div class="modal-footer">
						<button
							type="button"
							id="close"
							class="btn btn-secondary"
							data-bs-dismiss="modal"
						>
							Chiudi
						</button>
						<button
							type="button"
							class="btn btn-primary"
							:class="{ loading: loading }"
							@click="save"
						>
							Salva
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { boxesService } from '@/services/BoxesService';
	import { horseStablesService } from '@/services/HorseStablesService';
	import CustomTable from '@/components/CustomTable';
	import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
	import { useTableData } from '../../../src/composables/useTableData';
	import { useToast } from 'vue-toastification';
	const toast = useToast();

	export default {
		name: 'Soci',
		components: { CustomTable },
		data() {
			return {
				box: {},
				boxes: [],
				loading: false,
				modalTitle: this.$t('add'),
			};
		},
		computed: {
			box_types() {
				const boxesType = boxesService.box_types;
				let typeItems = [];
				boxesType.forEach((type) => {
					typeItems.push({ value: type.id, label: type.name });
				});
				return typeItems;
			},
			stableName() {
				return horseStablesService.horseStables.find(
					(stable) => stable.id == this.horseStable_id
				).name;
			},
			horse_stables() {
				const stables = horseStablesService.horseStables;
				let stableItems = [];
				stables.forEach((stable) => {
					stableItems.push({ value: stable.id, label: stable.name });
				});

				return stableItems;
			},
		},
		props: {
			horseStable_id: {
				type: [String, Number],
				required: true,
			},
		},
		setup() {
			const tableData = useTableData(
				boxesService.getBoxes.bind(boxesService),
				10
			);
			return tableData;
		},

		methods: {
			runAction({ action, row }) {
				this.loading = true;
				if (action.key == 'edit') {
					this.modalTitle = this.$t('edit');
					this.box = boxesService.getBoxById(row.id);
					this.box.id = row.id;
					this.loading = false;
					const modalElement = document.getElementById('formModal');
					const myModal = new bootstrap.Modal(modalElement);
					myModal.show();
				} else if (action.key == 'delete') {
					this.deleteBox(row.id);
				}
			},

			clear() {
				this.box = {};
				this.$refs.form$.reset();
				this.modalTitle = this.$t('add');
			},

			async save() {
				const form = this.$refs.form$;
				form.validate();
				if (this.box.id) form.data.id = this.box.id;
				if (!form.hasErrors) {
					for (const key in form.data) {
						if (form.data[key] === 'null' || form.data[key] === null) {
							delete form.data[key];
						}
					}
					this.loading = true;
					console.log(form.data);
					try {
						await boxesService.saveBox(this.horseStable_id, form.data);
						toast(this.$t('operation_saved'));
						document.getElementById('close').click();
						this.fetchBoxes();
					} finally {
						this.loading = false;
					}
				}
			},

			fetchBoxes() {
				this.fetchData({
					horse_stable_id: this.horseStable_id,
				});
			},
			async deleteBox(box_id) {
				if (
					!confirm(
						this.$t('irreversible_action') + '\n' + this.$t('do_u_confirm')
					)
				)
					return;
				await boxesService.deleteBox(box_id);
				this.fetchBoxes();
			},
		},
		create() {
			boxesService.getBoxesType();
		},
		mounted() {
			this.fetchBoxes();
			this.$store.dispatch('updateBreadcrumbs', [
				{ title: 'Scuderie', name: 'Scuderie' },
				{
					title: this.stableName,
					name: 'Box',
					params: { id: this.horseStable_id },
				},
			]);
		},
	};
</script>
